import { base64toFile, toBase64 } from 'commons/utils/object'

import type {
  JustificationNDOrder,
  JustificationNDOrderApi,
  JustificationNDOrderRequestData,
  JustificationNDOrderRequestDataApi,
  JustificationNDOrderResponseData,
  JustificationNDOrderResponseDataApi,
} from './interfaces'

export const toJustificationNDOrder = (data: JustificationNDOrderApi): JustificationNDOrder => {
  return {
    file: data.anexo ? base64toFile(data.anexo, data.nomeAnexo) : null,
    fileName: data.nomeAnexo,
    reasonId: data.codigoMotivo,
    requestDescription: data.justificativa,
  }
}

export const toJustificationNDOrderResponseData = (
  data: JustificationNDOrderResponseDataApi,
): JustificationNDOrderResponseData => {
  return {
    ...data,
    data: toJustificationNDOrder(data.data),
  }
}

export const toJustificationNDOrderRequestDataApi = async (
  data: JustificationNDOrderRequestData,
): Promise<JustificationNDOrderRequestDataApi> => {
  const fileBase64 = data.file
    ? ((await toBase64(data.file)) as string).split(',')[1] // NOTE: Remove the prefix 'data:application/pdf;base64,' from the base64 string
    : null

  return {
    anexo: fileBase64,
    codigoMotivo: data.reasonId,
    justificativa: data.requestDescription,
    nomeAnexo: data.fileName,
    numeroPedido: data.orderNumber,
  }
}
